export const ItemText = ({ text }) => (
  <>
    <span>{text}</span>
  </>
);
